
import React, { useState } from 'react';
import './CreateProduct.css';
import SecondaryFooter from '../Common/SecondaryFooter';
import config from '../../environment/config';
import { fetchDrafts, createDraft, updateDraft, deleteDraft } from "../../service/draftService";
import AdminLayout from '../Common/AdminLayout';


const CreateProduct = () => {

    const [activeTab, setActiveTab] = useState('details');


    const [productDetails, setProductDetails] = useState({
        name: '',
        organisationName: '',
        category: '',
        shortDescription: '',
        overview: '',
        highlights: '',
        status: true
    });


    const [features, setFeatures] = useState([
        { id: Date.now(), name: '', description: '' }
    ]);

    const [plans, setPlans] = useState([
        { id: Date.now(), name: '', type: 'Monthly', currency: 'Rupee', amount: '', description: '' }
    ]);


    const [specifications, setSpecifications] = useState([
        { id: Date.now(), name: '', details: '' }
    ]);


    const [support, setSupport] = useState([
        { id: Date.now(), name: '', details: '' }
    ]);


    const [reviews, setReviews] = useState([
        { id: Date.now(), reviewerName: '', rating: 5, text: '', date: '' }
    ]);


    const [loading, setLoading] = useState(false);
    const [apiMessage, setApiMessage] = useState({ type: '', text: '' });
    const [showPreview, setShowPreview] = useState(false);


    const tabs = [
        { id: 'details', label: 'Product Details', icon: '📦' },
        { id: 'features', label: 'Features', icon: '⚡' },
        { id: 'plans', label: 'Plans & Pricing', icon: '💰' },
        { id: 'specifications', label: 'Specifications', icon: '📋' },
        { id: 'support', label: 'Support', icon: '🛟' }
    ];


    const handleProductDetailChange = (field, value) => {
        // Convert to Title Case (Camel Case) if field is 'name'
        if (field === 'name') {
            value = value
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }

        setProductDetails(prev => ({ ...prev, [field]: value }));
    };

    const addFeature = () => {
        setFeatures([...features, { id: Date.now(), name: '', description: '' }]);
    };

    const updateFeature = (id, field, value) => {
        setFeatures(features.map(f => f.id === id ? { ...f, [field]: value } : f));
    };

    const removeFeature = (id) => {
        if (features.length > 1) {
            setFeatures(features.filter(f => f.id !== id));
        }
    };

    // Plan handlers
    const addPlan = () => {
        setPlans([...plans, { id: Date.now(), name: '', type: 'Monthly', currency: 'Rupee', amount: '', description: '' }]);
    };

    const updatePlan = (id, field, value) => {
        setPlans(plans.map(p => p.id === id ? { ...p, [field]: value } : p));
    };

    const removePlan = (id) => {
        if (plans.length > 1) {
            setPlans(plans.filter(p => p.id !== id));
        }
    };

    // Specification handlers
    const addSpecification = () => {
        setSpecifications([...specifications, { id: Date.now(), name: '', details: '' }]);
    };

    const updateSpecification = (id, field, value) => {
        setSpecifications(specifications.map(s => s.id === id ? { ...s, [field]: value } : s));
    };

    const removeSpecification = (id) => {
        if (specifications.length > 1) {
            setSpecifications(specifications.filter(s => s.id !== id));
        }
    };

    // Support handlers
    const addSupport = () => {
        setSupport([...support, { id: Date.now(), name: '', details: '' }]);
    };

    const updateSupport = (id, field, value) => {
        setSupport(support.map(s => s.id === id ? { ...s, [field]: value } : s));
    };

    const removeSupport = (id) => {
        if (support.length > 1) {
            setSupport(support.filter(s => s.id !== id));
        }
    };

    // Review handlers
    const addReview = () => {
        setReviews([...reviews, { id: Date.now(), reviewerName: '', rating: 5, text: '', date: '' }]);
    };

    const updateReview = (id, field, value) => {
        setReviews(reviews.map(r => r.id === id ? { ...r, [field]: value } : r));
    };

    const removeReview = (id) => {
        if (reviews.length > 1) {
            setReviews(reviews.filter(r => r.id !== id));
        }
    };

    // Map category name to ID
    const getCategoryId = (categoryName) => {
        const categoryMap = {
            'seo-tools': 1,
            'e-learning': 2,
            'talent-acquisition': 3,
            'workflow-automation': 4,
            'digital-marketing': 5,
            'analytics-reporting': 6
        };
        return categoryMap[categoryName] || 1;
    };

    const getCategoryLabel = (categoryValue) => {
        const labels = {
            'seo-tools': 'SEO Tools',
            'e-learning': 'E-Learning',
            'talent-acquisition': 'Talent Acquisition',
            'workflow-automation': 'Workflow Automation',
            'digital-marketing': 'Digital Marketing',
            'analytics-reporting': 'Analytics & Reporting'
        };
        return labels[categoryValue] || categoryValue;
    };

    const getCurrencySymbol = (currency) => {
        return currency === 'Rupee' ? '₹' : '$';
    };

    // Map plan type to single character
    const mapPlanType = (type) => {
        const typeMap = {
            'Monthly': 'M',
            'Quarterly': 'Q',
            'Yearly': 'Y',
            'Custom': 'C'
        };
        return typeMap[type] || 'M';
    };

    // Map currency to single character
    const mapCurrency = (currency) => {
        const currencyMap = {
            'Rupee': 'R',
            'Dollar': 'D'
        };
        return currencyMap[currency] || 'R';
    };


    // Add this function to your CreateProduct.jsx component

    const handleSaveDraft = async () => {
        console.log('💾 Saving draft...');
        setLoading(true);

        try {
            const API_BASE_URL = config.API_URL;

            // Get token from localStorage (stored as 'token')
            let token = localStorage.getItem('token') ||
                localStorage.getItem('jhi-authenticationToken') ||
                localStorage.getItem('authToken') ||
                sessionStorage.getItem('token');

            console.log('🔑 Token found:', token ? 'Yes ✓' : 'No ✗');

            // Remove "Bearer " prefix if it exists
            if (token && token.startsWith('Bearer ')) {
                token = token.substring(7);
            }

            if (!token) {
                console.error('❌ No authentication token found!');
                setApiMessage({
                    type: 'error',
                    text: '⚠️ Authentication token not found. Please log in again.'
                });
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setLoading(false);
                return;
            }

            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };

            // Validate required fields
            if (!productDetails.name || !productDetails.category || !productDetails.shortDescription) {
                setApiMessage({
                    type: 'error',
                    text: '❌ Product name, category, and short description are required to save draft'
                });
                setLoading(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            // Step 1: Prepare product details payload with publish_flag = 'N'
            const productDetailsPayload = {
                productId: null,
                productName: productDetails.name,
                categoryId: getCategoryId(productDetails.category),
                productDescription: productDetails.shortDescription,
                productOverview: productDetails.overview,
                productHighlights: productDetails.highlights,
                isActive: 0,
                publishFlag: 'N'
            };

            console.log('📤 Saving draft to seo-product-details:', productDetailsPayload);

            const response = await fetch(`${API_BASE_URL}/api/seo-product-details`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(productDetailsPayload)
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to save draft: ${response.status} - ${errorText}`);
            }

            const savedProduct = await response.json();
            const productId = savedProduct.productId;

            console.log('✅ Draft saved successfully with Product ID:', productId);

            // Step 2: Save Features
            const validFeatures = features.filter(f => f.name && f.name.trim() !== '');
            if (validFeatures.length > 0) {
                console.log('⚡ Saving', validFeatures.length, 'features...');

                const featurePromises = validFeatures.map(feature =>
                    fetch(`${API_BASE_URL}/api/seo-product-features`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            featureName: feature.name,
                            featureDescription: feature.description,
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to save feature: ${feature.name}`);
                        return res.json();
                    })
                );

                await Promise.all(featurePromises);
                console.log('✅ Features saved');
            }

            // Step 3: Save Plans
            const validPlans = plans.filter(p => p.name && p.amount);
            if (validPlans.length > 0) {
                console.log('💰 Saving', validPlans.length, 'plans...');

                const planPromises = validPlans.map(plan =>
                    fetch(`${API_BASE_URL}/api/seo-product-plans`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            planName: plan.name,
                            planType: mapPlanType(plan.type),
                            planAmountType: mapCurrency(plan.currency),
                            planAmount: parseFloat(plan.amount),
                            planDescription: plan.description,
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to save plan: ${plan.name}`);
                        return res.json();
                    })
                );

                await Promise.all(planPromises);
                console.log('✅ Plans saved');
            }

            // Step 4: Save Specifications
            const validSpecs = specifications.filter(s => s.name && s.name.trim() !== '');
            if (validSpecs.length > 0) {
                console.log('📋 Saving', validSpecs.length, 'specifications...');

                const specPromises = validSpecs.map(spec =>
                    fetch(`${API_BASE_URL}/api/seo-product-specifications`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            specificationName: spec.name,
                            specificationDetails: spec.details,
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to save specification: ${spec.name}`);
                        return res.json();
                    })
                );

                await Promise.all(specPromises);
                console.log('✅ Specifications saved');
            }

            // Step 5: Save Support
            const validSupport = support.filter(s => s.name && s.name.trim() !== '');
            if (validSupport.length > 0) {
                console.log('🛟 Saving', validSupport.length, 'support options...');

                const supportPromises = validSupport.map(sup =>
                    fetch(`${API_BASE_URL}/api/seo-product-supports`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            supportName: sup.name,
                            supportDetails: sup.details,
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to save support: ${sup.name}`);
                        return res.json();
                    })
                );

                await Promise.all(supportPromises);
                console.log('✅ Support options saved');
            }

            // Step 6: Save Reviews
            const validReviews = reviews.filter(r => r.reviewerName && r.reviewerName.trim() !== '');
            if (validReviews.length > 0) {
                console.log('⭐ Saving', validReviews.length, 'reviews...');

                const reviewPromises = validReviews.map(review =>
                    fetch(`${API_BASE_URL}/api/seo-product-reviews`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            reviewBy: review.reviewerName,
                            reviewDescription: review.text,
                            reviewRating: parseInt(review.rating),
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to save review by: ${review.reviewerName}`);
                        return res.json();
                    })
                );

                await Promise.all(reviewPromises);
                console.log('✅ Reviews saved');
            }

            // Show success message
            setApiMessage({
                type: 'success',
                text: `✅ Draft saved successfully! Product ID: ${productId}`
            });

            window.scrollTo({ top: 0, behavior: 'smooth' });

            // Clear message after 3 seconds
            setTimeout(() => {
                setApiMessage({ type: '', text: '' });
            }, 3000);

        } catch (error) {
            console.error('❌ Error saving draft:', error);
            setApiMessage({
                type: 'error',
                text: `❌ Failed to save draft: ${error.message}`
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        finally {
            setLoading(false);
        }
    };
    // Publish handler with complete error handling
    const handlePublish = async () => {
        setLoading(true);
        setApiMessage({ type: '', text: '' });

        try {
            // Step 1: Validate
            if (!productDetails.name || !productDetails.category || !productDetails.shortDescription) {
                setApiMessage({
                    type: 'error',
                    text: '❌ Product name, category, and short description are required'
                });
                setLoading(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            // FIXED: Use config.API_URL directly without extra /api/seo-user
            const API_BASE_URL = config.API_URL;
            console.log('🌐 API Base URL:', API_BASE_URL);

            // Get JWT token if available
            // Get JWT token if available (stored as 'token')
            const token = localStorage.getItem('token') ||
                localStorage.getItem('jhi-authenticationToken') ||
                localStorage.getItem('authToken') ||
                sessionStorage.getItem('token');

            console.log('🔑 Using token:', token ? 'Yes' : 'No');

            // FIXED: Create headers object properly
            const headers = {
                'Content-Type': 'application/json'
            };

            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }

            // Step 2: Create Product Details
            const productDetailsPayload = {
                productId: null,
                productName: productDetails.name,
                categoryId: getCategoryId(productDetails.category),
                productDescription: productDetails.shortDescription,
                productOverview: productDetails.overview,
                productHighlights: productDetails.highlights,
                isActive: productDetails.status ? 1 : 0,
                publishFlag: 'Y'
            };

            console.log('📦 Creating product details:', productDetailsPayload);

            const productResponse = await fetch(`${API_BASE_URL}/api/seo-product-details`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(productDetailsPayload)
            });

            console.log('📦 Product response status:', productResponse.status);

            if (!productResponse.ok) {
                const errorText = await productResponse.text();
                console.error('❌ Product creation error:', errorText);

                let errorMessage = 'Failed to create product';
                try {
                    const errorJson = JSON.parse(errorText);
                    errorMessage = errorJson.message || errorJson.title || errorMessage;
                } catch (e) {
                    errorMessage = errorText || errorMessage;
                }

                throw new Error(errorMessage);
            }

            const productData = await productResponse.json();
            const productId = productData.productId;

            console.log('✅ Product created with ID:', productId);

            // Step 3: Create Features
            const validFeatures = features.filter(f => f.name && f.name.trim() !== '');
            if (validFeatures.length > 0) {
                console.log('⚡ Creating', validFeatures.length, 'features...');

                const featurePromises = validFeatures.map(feature =>
                    fetch(`${API_BASE_URL}/api/seo-product-features`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            featureName: feature.name,
                            featureDescription: feature.description,
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to create feature: ${feature.name}`);
                        return res.json();
                    })
                );

                await Promise.all(featurePromises);
                console.log('✅ Features created');
            }

            // Step 4: Create Plans
            const validPlans = plans.filter(p => p.name && p.amount);
            if (validPlans.length > 0) {
                console.log('💰 Creating', validPlans.length, 'plans...');

                const planPromises = validPlans.map(plan =>
                    fetch(`${API_BASE_URL}/api/seo-product-plans`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            planName: plan.name,
                            planType: mapPlanType(plan.type),
                            planAmountType: mapCurrency(plan.currency),
                            planAmount: parseFloat(plan.amount),
                            planDescription: plan.description,
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to create plan: ${plan.name}`);
                        return res.json();
                    })
                );

                await Promise.all(planPromises);
                console.log('✅ Plans created');
            }

            // Step 5: Create Specifications
            const validSpecs = specifications.filter(s => s.name && s.name.trim() !== '');
            if (validSpecs.length > 0) {
                console.log('📋 Creating', validSpecs.length, 'specifications...');

                const specPromises = validSpecs.map(spec =>
                    fetch(`${API_BASE_URL}/api/seo-product-specifications`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            specificationName: spec.name,
                            specificationDetails: spec.details,
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to create specification: ${spec.name}`);
                        return res.json();
                    })
                );

                await Promise.all(specPromises);
                console.log('✅ Specifications created');
            }



            // Step 6: Save Support (FIXED VERSION)
            const validSupport = support.filter(s => s.name && s.name.trim() !== '');
            if (validSupport.length > 0) {
                console.log('🛟 Saving', validSupport.length, 'support options...');
                console.log('📋 Support data:', validSupport);

                for (const sup of validSupport) {
                    const supportPayload = {
                        supportId: null, // Important: Don't send supportId for new records
                        productId: productId,
                        supportName: sup.name,
                        supportDetails: sup.details,
                        isActive: 1 // Required field
                    };

                    console.log('📤 Sending support payload:', supportPayload);

                    try {
                        const response = await fetch(`${API_BASE_URL}/api/seo-product-supports`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(supportPayload)
                        });

                        console.log('📥 Support response status:', response.status);

                        if (!response.ok) {
                            const errorText = await response.text();
                            console.error('❌ Support API error:', {
                                status: response.status,
                                statusText: response.statusText,
                                error: errorText,
                                payload: supportPayload
                            });
                            throw new Error(`Failed to save support "${sup.name}": ${response.status} - ${errorText}`);
                        }

                        const result = await response.json();
                        console.log('✅ Support saved:', result);
                    } catch (error) {
                        console.error('❌ Exception saving support:', error);
                        throw error; // Re-throw to stop the process
                    }
                }

                console.log('✅ All support options saved successfully');
            }

            // Step 7: Create Reviews
            const validReviews = reviews.filter(r => r.reviewerName && r.reviewerName.trim() !== '');
            if (validReviews.length > 0) {
                console.log('⭐ Creating', validReviews.length, 'reviews...');

                const reviewPromises = validReviews.map(review =>
                    fetch(`${API_BASE_URL}/api/seo-product-reviews`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            productId: productId,
                            reviewBy: review.reviewerName,
                            reviewDescription: review.text,
                            reviewRating: parseInt(review.rating),
                            isActive: 1
                        })
                    }).then(res => {
                        if (!res.ok) throw new Error(`Failed to create review by: ${review.reviewerName}`);
                        return res.json();
                    })
                );

                await Promise.all(reviewPromises);
                console.log('✅ Reviews created');
            }

            // Success!
            console.log('🎉 All done! Product ID:', productId);

            setApiMessage({
                type: 'success',
                text: `✅ Product created successfully! Product ID: ${productId}`
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });

            // Reset form after 3 seconds
            setTimeout(() => {
                setProductDetails({
                    name: '',
                    category: '',
                    shortDescription: '',
                    overview: '',
                    highlights: '',
                    status: true
                });
                setFeatures([{ id: Date.now(), name: '', description: '' }]);
                setPlans([{ id: Date.now(), name: '', type: 'Monthly', currency: 'Rupee', amount: '', description: '' }]);
                setSpecifications([{ id: Date.now(), name: '', details: '' }]);
                setSupport([{ id: Date.now(), name: '', details: '' }]);
                setReviews([{ id: Date.now(), reviewerName: '', rating: 5, text: '', date: '' }]);
                setActiveTab('details');
                setApiMessage({ type: '', text: '' });
            }, 3000);

        } catch (error) {
            console.error('❌ Error during product creation:', error);

            setApiMessage({
                type: 'error',
                text: `❌ ${error.message}`
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } finally {
            setLoading(false);
        }
    };

    // Calculate completion percentage
    const calculateCompletion = () => {
        let total = 0;
        let filled = 0;

        // Product details (5 fields)
        if (productDetails.name) filled++;
        if (productDetails.category) filled++;
        if (productDetails.shortDescription) filled++;
        if (productDetails.overview) filled++;
        if (productDetails.highlights) filled++;
        total += 5;

        // Features
        features.forEach(f => {
            if (f.name) filled++;
            if (f.description) filled++;
            total += 2;
        });

        // Plans
        plans.forEach(p => {
            if (p.name) filled++;
            if (p.amount) filled++;
            if (p.description) filled++;
            total += 3;
        });

        return total > 0 ? Math.round((filled / total) * 100) : 0;
    };

    const completionPercent = calculateCompletion();

    return (
        <AdminLayout>
            <div className="create-product-page">
                {/* Hero Header with Gradient */}
                <div className="page-hero">
                    <div className="hero-content">
                        <div className="hero-badge">Admin Panel</div>
                        <h1 className="hero-title">Create New Product</h1>
                        <p className="hero-subtitle">
                            Build and configure your product with our intuitive admin tools
                        </p>
                    </div>
                    <div className="hero-decoration"></div>
                </div>

                {/* API Message Display */}
                {apiMessage.text && (
                    <div className={`api-message ${apiMessage.type}`}>
                        <div className="message-content">
                            {apiMessage.text}
                        </div>
                        <button
                            className="message-close"
                            onClick={() => setApiMessage({ type: '', text: '' })}
                        >
                            ×
                        </button>
                    </div>
                )}

                <div className="page-layout">
                    {/* Main Content Area */}
                    <div className="main-content">
                        {/* Tabs */}
                        <div className="tabs-container">
                            <div className="tabs-navigation">
                                {tabs.map(tab => (
                                    <button
                                        key={tab.id}
                                        className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                                        onClick={() => setActiveTab(tab.id)}
                                    >
                                        <span className="tab-icon">{tab.icon}</span>
                                        <span className="tab-label">{tab.label}</span>
                                    </button>
                                ))}
                            </div>

                            <div className="tab-content">
                                {/* TAB 1: Product Details */}
                                {activeTab === 'details' && (
                                    <div className="tab-panel">
                                        <div className="panel-header">
                                            <h2 className="panel-title">Basic Information</h2>
                                            <p className="panel-description">Enter the core details about your product</p>
                                        </div>

                                        <div className="form-grid">
                                            <div className="form-group">
                                                <label htmlFor="productName">Product Name *</label>
                                                <input
                                                    type="text"
                                                    id="productName"
                                                    className="form-input"
                                                    placeholder="Enter a compelling product name"
                                                    value={productDetails.name}
                                                    onChange={(e) => handleProductDetailChange('name', e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="organisationName">Organisation Name</label>
                                                <input
                                                    type="text"
                                                    id="organisationName"
                                                    className="form-input"
                                                    placeholder="Enter organisation name"
                                                    value={productDetails.organisationName}
                                                    onChange={(e) => handleProductDetailChange('organisationName', e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="category">Category *</label>
                                                <select
                                                    id="category"
                                                    className="form-input"
                                                    value={productDetails.category}
                                                    onChange={(e) => handleProductDetailChange('category', e.target.value)}
                                                >
                                                    <option value="">Select a category</option>
                                                    <option value="seo-tools">🔍 SEO Tools</option>
                                                    <option value="e-learning">📚 E-Learning</option>
                                                    <option value="talent-acquisition">👥 Talent Acquisition</option>
                                                    <option value="workflow-automation">⚙️ Workflow Automation</option>
                                                    <option value="digital-marketing">📢 Digital Marketing</option>
                                                    <option value="analytics-reporting">📊 Analytics & Reporting</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="shortDescription">Short Description *</label>
                                            <textarea
                                                id="shortDescription"
                                                className="form-textarea"
                                                rows="2"
                                                placeholder="A brief, catchy description (1-2 sentences)"
                                                value={productDetails.shortDescription}
                                                onChange={(e) => handleProductDetailChange('shortDescription', e.target.value)}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="overview">Product Overview</label>
                                            <textarea
                                                id="overview"
                                                className="form-textarea large"
                                                rows="6"
                                                placeholder="Provide a comprehensive overview of your product, its purpose, and key benefits..."
                                                value={productDetails.overview}
                                                onChange={(e) => handleProductDetailChange('overview', e.target.value)}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="highlights">Product Highlights</label>
                                            <textarea
                                                id="highlights"
                                                className="form-textarea"
                                                rows="4"
                                                placeholder="List key highlights (one per line)"
                                                value={productDetails.highlights}
                                                onChange={(e) => handleProductDetailChange('highlights', e.target.value)}
                                            />
                                        </div>

                                        <div className="form-group status-group">
                                            <div className="status-label">
                                                <span className="label-text">Product Status</span>
                                                <span className="status-badge">{productDetails.status ? '🟢 Active' : '🔴 Inactive'}</span>
                                            </div>
                                            <label className="toggle-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={productDetails.status}
                                                    onChange={(e) => handleProductDetailChange('status', e.target.checked)}
                                                />
                                                <span className="toggle-slider"></span>
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {/* TAB 2: Features */}
                                {activeTab === 'features' && (
                                    <div className="tab-panel">
                                        <div className="panel-header">
                                            <h2 className="panel-title">Product Features</h2>
                                            <p className="panel-description">Define the key features that make your product stand out</p>
                                        </div>

                                        <div className="dynamic-list">
                                            {features.map((feature, index) => (
                                                <div key={feature.id} className="dynamic-card">
                                                    <div className="card-header">
                                                        <div className="card-badge">Feature {index + 1}</div>
                                                        {features.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn-remove-icon"
                                                                onClick={() => removeFeature(feature.id)}
                                                                title="Remove feature"
                                                            >
                                                                ✕
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="form-group">
                                                            <label>Feature Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                placeholder="e.g., Advanced Analytics Dashboard"
                                                                value={feature.name}
                                                                onChange={(e) => updateFeature(feature.id, 'name', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Feature Description</label>
                                                            <textarea
                                                                className="form-textarea"
                                                                rows="3"
                                                                placeholder="Describe what this feature does and why it's valuable..."
                                                                value={feature.description}
                                                                onChange={(e) => updateFeature(feature.id, 'description', e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <button type="button" className="btn-add-new" onClick={addFeature}>
                                            <span className="btn-icon">+</span>
                                            Add Another Feature
                                        </button>
                                    </div>
                                )}

                                {/* TAB 3: Plans & Pricing */}
                                {activeTab === 'plans' && (
                                    <div className="tab-panel">
                                        <div className="panel-header">
                                            <h2 className="panel-title">Pricing Plans</h2>
                                            <p className="panel-description">Configure pricing tiers for your product</p>
                                        </div>

                                        <div className="dynamic-list">
                                            {plans.map((plan, index) => (
                                                <div key={plan.id} className="dynamic-card pricing-card">
                                                    <div className="card-header">
                                                        <div className="card-badge">Plan {index + 1}</div>
                                                        {plans.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn-remove-icon"
                                                                onClick={() => removePlan(plan.id)}
                                                                title="Remove plan"
                                                            >
                                                                ✕
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="form-grid">
                                                            <div className="form-group">
                                                                <label>Plan Name</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-input"
                                                                    placeholder="e.g., Basic, Pro, Enterprise"
                                                                    value={plan.name}
                                                                    onChange={(e) => updatePlan(plan.id, 'name', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Billing Cycle</label>
                                                                <select
                                                                    className="form-input"
                                                                    value={plan.type}
                                                                    onChange={(e) => updatePlan(plan.id, 'type', e.target.value)}
                                                                >
                                                                    <option value="Monthly">📅 Monthly</option>
                                                                    <option value="Quarterly">📆 Quarterly</option>
                                                                    <option value="Yearly">🗓️ Yearly</option>
                                                                    <option value="Custom">⚙️ Custom</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="form-grid">
                                                            <div className="form-group">
                                                                <label>Currency</label>
                                                                <select
                                                                    className="form-input"
                                                                    value={plan.currency}
                                                                    onChange={(e) => updatePlan(plan.id, 'currency', e.target.value)}
                                                                >
                                                                    <option value="Rupee">₹ Indian Rupee</option>
                                                                    <option value="Dollar">$ US Dollar</option>
                                                                </select>
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Price Amount</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-input"
                                                                    placeholder="0.00"
                                                                    value={plan.amount}
                                                                    onChange={(e) => updatePlan(plan.id, 'amount', e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Plan Description</label>
                                                            <textarea
                                                                className="form-textarea"
                                                                rows="3"
                                                                placeholder="What's included in this plan? List features and benefits..."
                                                                value={plan.description}
                                                                onChange={(e) => updatePlan(plan.id, 'description', e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <button type="button" className="btn-add-new" onClick={addPlan}>
                                            <span className="btn-icon">+</span>
                                            Add Another Plan
                                        </button>
                                    </div>
                                )}

                                {/* TAB 4: Specifications */}
                                {activeTab === 'specifications' && (
                                    <div className="tab-panel">
                                        <div className="panel-header">
                                            <h2 className="panel-title">Technical Specifications</h2>
                                            <p className="panel-description">Add technical details and specifications</p>
                                        </div>

                                        <div className="dynamic-list">
                                            {specifications.map((spec, index) => (
                                                <div key={spec.id} className="dynamic-card compact-card">
                                                    <div className="card-header">
                                                        <div className="card-badge">Spec {index + 1}</div>
                                                        {specifications.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn-remove-icon"
                                                                onClick={() => removeSpecification(spec.id)}
                                                                title="Remove specification"
                                                            >
                                                                ✕
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="form-grid">
                                                            <div className="form-group">
                                                                <label>Specification Name</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-input"
                                                                    placeholder="e.g., API Rate Limit"
                                                                    value={spec.name}
                                                                    onChange={(e) => updateSpecification(spec.id, 'name', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Details</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-input"
                                                                    placeholder="e.g., 10,000 requests/hour"
                                                                    value={spec.details}
                                                                    onChange={(e) => updateSpecification(spec.id, 'details', e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <button type="button" className="btn-add-new" onClick={addSpecification}>
                                            <span className="btn-icon">+</span>
                                            Add Another Specification
                                        </button>
                                    </div>
                                )}

                                {/* TAB 5: Support */}
                                {activeTab === 'support' && (
                                    <div className="tab-panel">
                                        <div className="panel-header">
                                            <h2 className="panel-title">Support Options</h2>
                                            <p className="panel-description">Define customer support channels and resources</p>
                                        </div>

                                        <div className="dynamic-list">
                                            {support.map((item, index) => (
                                                <div key={item.id} className="dynamic-card">
                                                    <div className="card-header">
                                                        <div className="card-badge">Support {index + 1}</div>
                                                        {support.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn-remove-icon"
                                                                onClick={() => removeSupport(item.id)}
                                                                title="Remove support option"
                                                            >
                                                                ✕
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="form-group">
                                                            <label>Support Channel</label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                placeholder="e.g., 24/7 Live Chat, Email Support"
                                                                value={item.name}
                                                                onChange={(e) => updateSupport(item.id, 'name', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Support Details</label>
                                                            <textarea
                                                                className="form-textarea"
                                                                rows="3"
                                                                placeholder="Describe availability, response time, and other details..."
                                                                value={item.details}
                                                                onChange={(e) => updateSupport(item.id, 'details', e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <button type="button" className="btn-add-new" onClick={addSupport}>
                                            <span className="btn-icon">+</span>
                                            Add Another Support Option
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Action Buttons - Now inside main content, before footer */}

                        <div className="action-section">
                            <button
                                type="button"
                                className="btn-secondary preview-btn"
                                onClick={() => setShowPreview(true)}
                            >
                                Preview Product
                            </button>

                            <button
                                type="button"
                                className="btn-secondary draft-btn"
                                onClick={handleSaveDraft}
                            >
                                Save Draft
                            </button>
                        </div>


                    </div>
                    {/* Preview Modal */}
                    {showPreview && (
                        <div className="preview-modal-overlay" onClick={() => setShowPreview(false)}>
                            <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
                                <div className="preview-header">
                                    <h2>Product Preview</h2>
                                    <button className="preview-close" onClick={() => setShowPreview(false)}>×</button>
                                </div>

                                <div className="preview-content">
                                    {/* Product Details Section */}
                                    <div className="preview-section">
                                        <h3>📦 Product Details</h3>
                                        <div className="preview-grid">
                                            <div><strong>Name:</strong> {productDetails.name || <span className="empty">Not provided</span>}</div>
                                            <div><strong>Category:</strong> {productDetails.category ? getCategoryLabel(productDetails.category) : <span className="empty">Not selected</span>}</div>
                                            <div><strong>Status:</strong> <span className={productDetails.status ? 'status-active' : 'status-inactive'}>{productDetails.status ? '🟢 Active' : '🔴 Inactive'}</span></div>
                                        </div>
                                        {productDetails.shortDescription && (
                                            <div className="preview-field">
                                                <strong>Short Description:</strong>
                                                <p>{productDetails.shortDescription}</p>
                                            </div>
                                        )}
                                        {productDetails.overview && (
                                            <div className="preview-field">
                                                <strong>Overview:</strong>
                                                <p>{productDetails.overview}</p>
                                            </div>
                                        )}
                                        {productDetails.highlights && (
                                            <div className="preview-field">
                                                <strong>Highlights:</strong>
                                                <pre className="preview-highlights">{productDetails.highlights}</pre>
                                            </div>
                                        )}
                                    </div>

                                    {/* Features Section */}
                                    {features.some(f => f.name) && (
                                        <div className="preview-section">
                                            <h3>⚡ Features ({features.filter(f => f.name).length})</h3>
                                            {features.filter(f => f.name).map((feature, idx) => (
                                                <div key={feature.id} className="preview-item">
                                                    <strong>{idx + 1}. {feature.name}</strong>
                                                    {feature.description && <p>{feature.description}</p>}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Plans Section */}
                                    {plans.some(p => p.name && p.amount) && (
                                        <div className="preview-section">
                                            <h3>💰 Pricing Plans ({plans.filter(p => p.name && p.amount).length})</h3>
                                            <div className="preview-plans">
                                                {plans.filter(p => p.name && p.amount).map((plan) => (
                                                    <div key={plan.id} className="preview-plan-card">
                                                        <div className="plan-header">
                                                            <h4>{plan.name}</h4>
                                                            <div className="plan-price">
                                                                {getCurrencySymbol(plan.currency)}{plan.amount}
                                                                <span className="plan-type">/{plan.type}</span>
                                                            </div>
                                                        </div>
                                                        {plan.description && <p>{plan.description}</p>}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Specifications Section */}
                                    {specifications.some(s => s.name) && (
                                        <div className="preview-section">
                                            <h3>📋 Specifications ({specifications.filter(s => s.name).length})</h3>
                                            <div className="preview-specs">
                                                {specifications.filter(s => s.name).map((spec) => (
                                                    <div key={spec.id} className="preview-spec-row">
                                                        <strong>{spec.name}:</strong>
                                                        <span>{spec.details || 'N/A'}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Support Section */}
                                    {support.some(s => s.name) && (
                                        <div className="preview-section">
                                            <h3>🛟 Support Options ({support.filter(s => s.name).length})</h3>
                                            {support.filter(s => s.name).map((item) => (
                                                <div key={item.id} className="preview-item">
                                                    <strong>{item.name}</strong>
                                                    {item.details && <p>{item.details}</p>}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="preview-footer">
                                    <button className="btn-secondary" onClick={() => setShowPreview(false)}>Close</button>
                                    <button className="btn-primary" onClick={() => { setShowPreview(false); handlePublish(); }}>
                                        Publish Product
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer at the bottom */}
                <SecondaryFooter />

            </div>
        </AdminLayout>
    );
};

export default CreateProduct;